import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import { LoginLink } from 'utils/link';
import DeleteMutation from 'mutations/session_info/delete_all';
import Confirmation from 'components/form/confirmation';

const DeleteAllButton = () => {
  const setError = useError();
  const navigate = useNavigate();

  const [deleteMutation, deleteMutationData] = useMutation(DeleteMutation, {
    onCompleted: () => {
      navigate(LoginLink());
    },
    onError: () => {
      setError('error.session_info.delete_all');
    },
  });

  return (
    <Confirmation
      title={<FormattedMessage id="header.session_info.delete_all" />}
      description={<FormattedMessage id="confirmation.session_info.delete_all" />}
      onClick={() => {
        deleteMutation();
      }}
    >
      <Button color="error" variant="outlined" disabled={deleteMutationData.loading}>
        <FormattedMessage id="button.logout.all" />
      </Button>
    </Confirmation>
  );
};

export default DeleteAllButton;
